import {
  ChangeDetectionStrategy,
  Component, input,
} from '@angular/core';

@Component({
  selector: 'app-lsap-icon',
  standalone: true,
  templateUrl: './lsap-icon.component.html',
  styleUrls: ['./lsap-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LsapIconComponent {
  name = input('');
  height = input<number | string>('auto');

  type = input<'svg' | 'png' | 'jpg'>('svg');
}
